/**
 * LanguagePicker
 * ==============
 * Small pill toggle (ES / EN) that calls `changeLocale`. Designed to be
 * dropped into any header (public or authenticated). Uses native country
 * flags as emoji to give visual context without depending on an extra icon
 * library.
 */
import React from 'react';
import { useI18n } from '../contexts/I18nContext';
import { cn } from '../lib/utils';

export function LanguagePicker({ className }) {
  const { locale, changeLocale } = useI18n();

  const btn = (code, label) => (
    <button
      key={code}
      type="button"
      onClick={() => changeLocale(code)}
      className={cn(
        'px-2.5 py-1 text-xs font-medium rounded-full transition-colors flex items-center gap-1',
        locale === code
          ? 'bg-primary text-primary-foreground'
          : 'text-muted-foreground hover:text-foreground'
      )}
      data-testid={`lang-picker-${code}`}
      aria-pressed={locale === code}
      aria-label={`Cambiar idioma a ${label}`}
    >
      {label}
    </button>
  );

  return (
    <div
      className={cn(
        'inline-flex items-center gap-0.5 p-0.5 bg-card/60 backdrop-blur border border-border/60 rounded-full',
        className,
      )}
      role="group"
      aria-label="Selector de idioma"
      data-testid="language-picker"
    >
      {btn('es', '🇲🇽 ES')}
      {btn('en', '🇺🇸 EN')}
    </div>
  );
}
